<template>
  <modal name="picture-details" height="auto" :scrollable="true">
    <button
      @click="hide('picture-details')"
      style="margin:5% 5%; cursor:pointer"
      class="pull-right"
    >
      <span class="mdi mdi-alpha-x-circle"></span>
    </button>
    <zoom-on-hover
      v-if="picture"
      :img-normal="picture"
      :scale="2"
    ></zoom-on-hover>
  </modal>
</template>

<script>
export default {
  props: {
    picture: {
      type: String,
    },
  },

  methods: {
    hide(modalName) {
      this.$modal.hide(modalName);
    },
  },
};
</script>
